// Insurance company availability by province
// This file defines which insurance companies are available in which provinces

export const INSURANCE_AVAILABILITY = {
  TUGO: {
    allowedProvinces: 'ALL', // TuGo는 모든 주에서 허용
    enabled: true,
  },
  ALLIANZ: {
    allowedProvinces: ['ON', 'QC'], // Allianz는 ON, QC만
    enabled: true,
  },
  BLUE_CROSS: {
    allowedProvinces: 'NONE', // 의미상, 어디서도 쓰지 않음
    enabled: false,          // ★ 여기 포인트: Blue Cross 완전 비활성화
  },
};

/**
 * Check if an insurance company is available for a given province
 * @param {string} companyName - Insurance company name (e.g., 'Tugo', 'Allianz', 'BlueCross')
 * @param {string} originProvince - Province code (e.g., 'ON', 'AB', 'BC')
 * @returns {boolean} True if the insurance is available for the province
 */
export function isInsuranceAvailable(companyName, originProvince) {
  // Normalize company name
  const normalizedName = companyName?.toUpperCase().replace(/\s+/g, '_');
  
  // Map company names to constants
  const companyMap = {
    'TUGO': 'TUGO',
    'ALLIANZ': 'ALLIANZ',
    'BLUECROSS': 'BLUE_CROSS',
    'BLUE_CROSS': 'BLUE_CROSS',
  };
  
  const key = companyMap[normalizedName];
  if (!key || !INSURANCE_AVAILABILITY[key]) {
    // Unknown company, default to false for safety
    return false;
  }
  
  const config = INSURANCE_AVAILABILITY[key];
  
  // If disabled, return false
  if (!config.enabled) {
    return false;
  }
  
  // If allowed in all provinces
  if (config.allowedProvinces === 'ALL') {
    return true;
  }
  
  // If not allowed in any province
  if (config.allowedProvinces === 'NONE') {
    return false;
  }
  
  // Check if province is in allowed list
  if (Array.isArray(config.allowedProvinces)) {
    return config.allowedProvinces.includes(originProvince);
  }
  
  return false;
}

/**
 * Check if an insurance object is Blue Cross
 * Supports multiple field names used across the codebase
 * @param {Object|string} insurance - Insurance object or company name string
 * @returns {boolean} True if the insurance is Blue Cross
 */
export function isBlueCross(insurance) {
  if (!insurance) return false;
  
  // If it's a string, check directly
  if (typeof insurance === 'string') {
    const normalized = insurance.toUpperCase().replace(/\s+/g, '');
    return normalized === 'BLUECROSS' || normalized === 'BLUE_CROSS';
  }
  
  // If it's an object, check common field names
  const companyName = insurance.compnayName || 
                      insurance.compnay_name || 
                      insurance.companyName || 
                      insurance.company_name ||
                      insurance.applicationCompany ||
                      insurance.selectedCompnayName ||
                      insurance.selectedCompanyName ||
                      '';
  
  const normalized = companyName.toUpperCase().replace(/\s+/g, '');
  return normalized === 'BLUECROSS' || normalized === 'BLUE_CROSS';
}

